const urlify = (value?: string | null) => {
  const url = value ?? "";

  if (url.startsWith("https://") || url.startsWith("http://")) {
    return url;
  }

  if (url) {
    return `https://${url}`;
  }

  return "";
};

export default urlify;
